/**
 * Brand color constants for use in components that need hex values
 * (e.g., pass generation, server-side rendering)
 *
 * For CSS usage, prefer the CSS variables:
 * - var(--primary-hex), var(--primary-rgb), var(--primary-light)
 * - var(--secondary-hex), var(--secondary-rgb)
 * - var(--grow-hex), var(--grow-rgb)
 */

// Primary purple color
export const PRIMARY_COLOR = '#5c3580';
export const PRIMARY_LIGHT = '#7e44ad';
export const PRIMARY_RGB = '92 53 128'; // space-separated for modern CSS rgb()

// Secondary cyan color
export const SECONDARY_COLOR = '#17f1d1';
export const SECONDARY_RGB = '23, 241, 209';

// Grow orange color
export const GROW_COLOR = '#ff9500';
export const GROW_RGB = '255, 149, 0';
